import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import SamparkAdminLayout from "../../../components/SamparkAdminLayout/SamparkAdminLayout";

function UpdateHaribhakt() {
  const apiURL = process.env.REACT_APP_API_URL;
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [surName, setSurname] = useState("");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [houseNo, setHouseNo] = useState("");
  const [street, setStreet] = useState("");
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [phone1, setPhone1] = useState("");
  const [phone2, setPhone2] = useState("");
  const [email, setEmail] = useState("");
  const [birthDate, setBirthdate] = useState("");
  const [dharmadaId, setDharmadaId] = useState("");
  const [type, setType] = useState("");
  const [relationId, setRelationId] = useState(0);
  const [attendenceStatus, setAttendenceStatus] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { id, haribhaktId, samparks } = location?.state || {};
  const currentPath = location?.pathname || "";

  useEffect(() => {
    const refreshToken = localStorage.getItem("refreshToken");
    const roles = localStorage.getItem("roles");
    if (!refreshToken || roles !== "SamparkAdmin") {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const config = {
          method: "get",
          url: `${apiURL}/User/Get/${haribhaktId}`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        };

        const response = await axios.request(config);
        const { data } = response.data;

        setFirstName(data.firstName);
        setLastName(data.lastName);
        setSurname(data.surName);
        setUserName(data.userName);
        setPassword(data.password);
        setPhone(data.contactNo);
        setPhone1(data.contactNo1);
        setPhone2(data.contactNo2);
        setEmail(data.emailId);
        setHouseNo(data.houseNo);
        setStreet(data.street);
        setAddress(data.address);
        setBirthdate(data.birthDate);
        setDharmadaId(data.dharmadaId);
        setType(data.type);
        setRelationId(data.relationId);
        setAttendenceStatus(data.attendenceStatus);

        if (data.imageBase64) {
          setImagePreview(data.imageBase64);
        } else if (data.imagePath) {
          setImagePreview(data.imagePath);
        }
      } catch (error) {
        toast.error(error.response.data.message);
      }
    };

    if (haribhaktId) {
      fetchData();
    }
  }, [haribhaktId]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
  
    if (file && file.type.startsWith("image/")) {
      setImage(file);
      setImagePreview(URL.createObjectURL(file));
  
      const fileLabel = document.getElementById("photoUpload");
      if (fileLabel) fileLabel.innerText = file.name; // Check if element exists
    } else {
      toast.error("Please select a valid image file (jpg, png, etc.)");
      setImage(null);
      setImagePreview(null);
  
      const fileLabel = document.getElementById("photoUpload");
      if (fileLabel) fileLabel.innerText = "Choose file"; // Check if element exists
    }
  };
  

  const handleSubmit = async (e) => {
    setLoaded(true);
    e.preventDefault();

    if (!/^\d{10}$/.test(phone)) {
      setLoaded(false);
      toast.error("Phone number must be exactly 10 digits.");
      return;
    }

    const data = new FormData();
    data.append("id", haribhaktId);

    if (image) {
      data.append("isImageDeleted", true);
      data.append("Image", image);
    } else {
      data.append("isImageDeleted", false);
    }

    data.append("mandalDetailsId", id);
    data.append("firstName", firstName);
    data.append("lastName", lastName);
    data.append("surName", surName);
    data.append("userName", userName);
    data.append("password", password);
    data.append("contactNo", phone);
    data.append("contactNo1", phone1 || "");
    data.append("contactNo2", phone2 || "");
    data.append("houseNo", houseNo);
    data.append("street", street);
    data.append("Address", address);
    data.append("emailId", email || "");
    data.append("birthDate", birthDate || "");
    data.append("dharmadaId", dharmadaId || "");
    data.append("type", type);
    data.append("relationId", relationId);
    data.append("AttendenceStatus", attendenceStatus);
    data.append("isVisible", "true");

    const config = {
      method: "post",
      url: `${apiURL}/User/Update`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      data: data,
    };

    try {
      const response = await axios.request(config);
      setLoaded(false);
      toast.success(
        response.data.message || "Mandal Admin Updated Successfully!"
      );

      if (currentPath === "/update-haribhakt4") {
        const timeOutId = setTimeout(() => {
          if (currentPath === "/update-haribhakt4") {
            navigate("/manage-haribhakt4", { state: { samparks: samparks } });
          }
        }, 3000);
        return () => clearTimeout(timeOutId);
      }
    } catch (error) {
      setLoaded(false);
      toast.error(error.response?.data?.message);
    }
  };

  return (
    <SamparkAdminLayout ac8="active">
      <section className="content-header pb-0">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-6">
              <h5>Update Haribhakt</h5>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/sampark-admin-dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/manage-haribhakt4" state={{ samparks: samparks }}>
                    Haribhakt List
                  </Link>
                </li>
                <li className="breadcrumb-item">Update Haribhakt</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="card card-default">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="haribhaktFirstname">First Name</label>
                      <span className="text-danger">*</span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="First Name"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="haribhaktLastname">Last Name</label>
                      <span className="text-danger">*</span>

                      <input
                        type="text"
                        className="form-control"
                        placeholder="Last Name"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="haribhaktSurname">Surname</label>
                      <span className="text-danger">*</span>

                      <input
                        type="text"
                        className="form-control"
                        placeholder="Surname"
                        value={surName}
                        onChange={(e) => setSurname(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="haribhaktUsername">Username</label>
                      <span className="text-danger">*</span>

                      <input
                        type="text"
                        className="form-control"
                        placeholder="Username"
                        value={userName}
                        onChange={(e) => setUserName(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="haribhaktPassword">Password</label>
                      <span className="text-danger">*</span>

                      <input
                        type="text"
                        className="form-control"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="haribhaktPhone">Phone</label>
                      <span className="text-danger">*</span>
                      <input
                        type="text"
                        className="form-control"
                        id="haribhaktPhone"
                        placeholder="Enter Haribhakt Phone Number"
                        value={phone}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,10}$/.test(value)) {
                            setPhone(value);
                          }
                        }}
                        required
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="haribhaktPhone1">Phone 1</label>
                      <input
                        type="text"
                        className="form-control"
                        id="haribhaktPhone1"
                        placeholder="Enter Haribhakt Phone Number"
                        value={phone1}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,10}$/.test(value)) {
                            setPhone1(value);
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="haribhaktPhone2">Phone 2</label>
                      <input
                        type="text"
                        className="form-control"
                        id="haribhaktPhone2"
                        placeholder="Enter Haribhakt Phone Number"
                        value={phone2}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,10}$/.test(value)) {
                            setPhone2(value);
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <label htmlFor="haribhaktImage">Upload Image</label>
                    <div className="input-group mb-3">
                      <div className="form-control d-flex align-items-center justify-content-center">
                        <label
                          className="w-100 text-muted"
                          style={{ cursor: "pointer" }}
                        >
                          {image ? image.name : "Upload Profile Photo"}
                          <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                            hidden
                          />
                        </label>
                      </div>
                      <div className="input-group-append">
                        <div className="input-group-text">
                          <span className="fas fa-camera"></span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    {imagePreview && (
                      <div>
                        <label className="mr-3">Preview: </label>
                        <img
                          src={imagePreview}
                          alt="Selected file preview"
                          className="img-preview"
                        />
                      </div>
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="haribhaktHouseNo">House No.</label>
                      <span className="text-danger">*</span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="House No."
                        value={houseNo}
                        onChange={(e) => setHouseNo(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="haribhaktStreet">Street</label>
                      <span className="text-danger">*</span>

                      <input
                        type="text"
                        className="form-control"
                        placeholder="Street"
                        value={street}
                        onChange={(e) => setStreet(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="haribhaktAddress">Address</label>
                      <input
                        className="form-control"
                        placeholder="Enter Address"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="haribhaktEmail">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="haribhaktBirthdate">Birthdate</label>
                      <input
                        type="date"
                        className="form-control"
                        placeholder="Birthdate"
                        value={birthDate}
                        onChange={(e) => setBirthdate(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="haribhaktDharmadaId">Dharmada Id</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Dharmada Id"
                        value={dharmadaId}
                        onChange={(e) => setDharmadaId(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="haribhaktDharmadaId">Relation Id</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Relation Id"
                        value={relationId}
                        onChange={(e) => setRelationId(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="card-footer">
                  <div className="float-right">
                    <button
                      type="button"
                      className="btn btn-primary mx-2"
                      onClick={() => window.history.back()}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loaded}
                    >
                      {loaded ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Loading...
                        </>
                      ) : (
                        <>Submit</>
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer position="top-center" style={{ width: "auto" }} />
    </SamparkAdminLayout>
  );
}

export default UpdateHaribhakt;
